<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Payment Link Transactions" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- users list start -->
        <section class="app-user-list">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                <BIconExclamationCircle width="26" height="26"/>
                Note
              </h4>
              <div class="row mr-1">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-gradient-danger"
                      @click="$router.push({ name: 'payment-link' })"
                  >
                    <span class="text-nowrap">Back</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="demo-spacing-0">
                <div class="alert alert-primary" role="alert">
                  <div class="alert-body">For queries and feedback please contact VaultsPay support team at: <strong><a
                      href="mailto: support@vaultspay.com">support@vaultspay.com</a></strong></div>
                </div>
              </div>
            </div>
          </div>
          <section id="alerts-with-title">
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title"><img width="150" :src="`${publicPath}images/vaults-authlogo.png`"></h4>
                    <h4 class="card-title float-right">
                      <BIconPersonCheckFill width="50" height="50" class="text-success ml-2"/>
                    </h4>
                  </div>
                  <div class="card-body" v-if="paymentInfo">
                    <div class="row">
                      <div class="col-6">
                        <h3 class="mb-1">To</h3>
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Merchant</span>
                          {{ $store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.first_name + ' ' + $store.getters.getLoggedInUser.last_name : '' }}
                        </h6>
                      </div>
                      <div class="col-6">
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Payment Link#</span>
                          {{ paymentInfo.token }}</h6>
                        <h6 class="mb-1 text-primary"><span
                            class="text-dark font-weight-bolder">Link Expiry Time Was:</span>
                          {{ paymentInfo.exipres_in }} seconds</h6>
                        <h6 v-if="paymentInfo.status_str == 'Active'" class="mb-1 text-success"><span
                            class="text-dark font-weight-bolder">Status:  </span>
                          <div class="ml-1 badge badge-glow badge-success">{{ paymentInfo.status_str }}</div>
                        </h6>
                        <h6 v-else class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Status:  </span>
                          <div class="ml-1 badge badge-glow badge-danger">{{ paymentInfo.status_str }}</div>
                        </h6>
                        <h6 class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Payment Link:  </span>
                          <button type="button" class="ml-1 btn btn-outline-info waves-effect btn-sm"><a
                              :href="paymentInfo.payment_url" class="text-info">Pay Now</a></button>
                        </h6>
                        <h6 class="mb-1 text-primary"><span
                            class="text-dark font-weight-bolder">Payment Link Amount:  </span>{{ parseFloat(paymentLinkAmount / 100).toFixed(amountDecimalPlaces
                        ) }}
                          <div class="badge badge-light-success ">{{ currency }}</div>
                        </h6>
                        <h6 class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Type:  </span>
                          <div class="badge badge-glow badge-dark ml-1">
                            {{ paymentInfo.type == 1 ? 'Multiple' : "Single" }}
                          </div>
                        </h6>
                        <h6 class="mb-1 text-primary"><span
                            class="text-dark font-weight-bolder">Total Transactions:  </span>{{ paymentInfo.transactions.length }}
                        </h6>
                      </div>
                    </div>
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="card">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>UUID</th>
                                <th>Gateway Reference Id</th>
                                <th>Customer</th>
                                <th>Customer Email</th>
                                <th>Amount</th>
                                <th>Vat</th>
                                <th>Fee</th>
                                <th>Total Amount</th>
                                <th>Receiver Account Title</th>
                                <th>Sender Account Title</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(item,index) in paymentInfo.transactions" :key="index">
                                <td style="cursor: pointer"
                                    @click="$router.push({name: 'transactions-details-with-id',params: {id:item.uuid}})">
                                  {{ item.uuid }}
                                </td>
                                <td>{{ item.gateway_reference_id }}</td>
                                <td>{{ item.customer?.name ?? 'N/A' }}</td>
                                <td>{{ item.customer?.email ?? 'N/A' }}</td>
                                <td>{{ parseFloat(item.amount / 100).toFixed(amountDecimalPlaces
                                ) }}</td>
                                <td>{{ parseFloat(item.vat / 100).toFixed(feesDecimalPlaces) }}</td>
                                <td>{{ parseFloat(item.fee / 100).toFixed(feesDecimalPlaces) }}</td>
                                <td>{{ parseFloat((item.total_amount - item.vat - item.fee) / 100).toFixed(amountDecimalPlaces) }}</td>
                                <td>{{ item.receiver_account_title }}</td>
                                <td>{{ item.sender_account_title }}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="card-body mt-5">
                            <div class="row">
                              <div class="col-7"></div>
                              <div class="col-5 bg-light-warning ">
                                <div class="row p-2 border-warning badge-glow">
                                  <div class="col-6">
                                    <h6 class="mb-2 text-primary"><span
                                        class="text-dark font-weight-bolder">Amount:</span></h6>
                                    <h6 class="mb-2 text-primary"><span class="text-dark font-weight-bolder">Vat:</span>
                                    </h6>
                                    <h6 class="mb-2 text-primary"><span class="text-dark font-weight-bolder">Fee:</span>
                                    </h6>
                                    <h6 class="mb-2 text-primary"><span
                                        class="text-dark font-weight-bolder">Subtotal:</span></h6>
                                  </div>
                                  <div class="col-2"></div>
                                  <div class="col-4">
                                    <h6 class="mb-2 text-primary">{{ parseFloat(totalAmount / 100).toFixed(amountDecimalPlaces
                                    ) }}
                                      <div class="badge badge-light-success ">{{ currency }}</div>
                                    </h6>
                                    <h6 class="mb-2 text-primary">{{ parseFloat(vat / 100).toFixed(feesDecimalPlaces) }}
                                      <div class="badge badge-light-success ">{{ currency }}</div>
                                    </h6>
                                    <h6 class="mb-2 text-primary">{{ parseFloat(fee / 100).toFixed(feesDecimalPlaces) }}
                                      <div class="badge badge-light-success ">{{ currency }}</div>
                                    </h6>
                                    <h6 class="mb-2 text-primary">
                                      {{ parseFloat((totalAmount - vat - fee) / 100).toFixed(amountDecimalPlaces
                                    ) }}
                                      <div class="badge badge-light-success ">{{ currency }}</div>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row ">
                      <div class="col-6">

                      </div>
                      <div class="col-6">
                       <div class="float-right">
                         <button @click="exportData('excel')" type="button" class="btn btn-gradient-success mr-1">
                           <div v-show="excelLoader" class="spinner-border text-white spinner-border-sm mr-1"></div>
                           <BIconFileEarmarkExcelFill width="20" height="20"/>
                           Export Excel
                         </button>
<!--                         <button @click="exportData('pdf')" type="button" class="btn btn-gradient-dark">-->
<!--                           <div v-show="pdfLoader" class="spinner-border text-white spinner-border-sm mr-1"></div>-->
<!--                           <BIconCloudDownloadFill width="20" height="20"/>-->
<!--                           Export PDf-->
<!--                         </button>-->
                       </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </section>
        <!-- users list ends -->

      </div>
    </div>
  </div>
</template>

<script>

import Button from "@/components/common/Button";
import {mapState} from "vuex";

export default {
  components: {Button},
  mounted() {
    this.sendCall()
  },
  computed: {
    ...mapState(['excelLoader','pdfLoader']),
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Payment Link'},
        {name: 'View'},
      ],
      paymentInfo: null,
      totalAmount: 0,
      vat: 0,
      fee: 0,
      currency: '',
      paymentLinkAmount: 0,


    }
  },
  methods: {
    sendCall() {
      this.makeRequest('post', 'v1/get-paymentlink-transactions', {paymentLinkId: this.$store.getters.getPaymentLinkDetail.id}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            if(callResponse.response.data.data){
              this.paymentInfo = callResponse.response.data.data
              this.currency = this.paymentInfo.currency.code
              this.paymentLinkAmount = this.paymentInfo.amount
              this.paymentInfo.transactions.forEach(v => {
                this.totalAmount += parseFloat(v.total_amount)
                this.vat += parseFloat(v.vat)
                this.fee += parseFloat(v.fee)
              })
            }

          }
        }

      });

    },
    exportData(exportType) {


      let requestData = {
        exportAs: exportType,
        reportType: 'payment_link_transactions',
        paymentLinkId: this.$store.getters.getPaymentLinkDetail.id,
        // token: this.paymentInfo?this.paymentInfo.token:'',
      }



      this.downloadReport(requestData)

    },
  },

}
</script>


